import "./MainComponents.css";
import "./Effects.css";

export function Heading(props: any) {
    return (<h1 className="heading glitch prevent-select" id={props.id}>
        <span aria-hidden="true">{props.children}</span>
        {props.children}
        <span aria-hidden="true">{props.children}</span>
    </h1>);
}